import { Component, OnInit } from '@angular/core';
import { ProjectService } from '../../../core/services/project.service';
import { SharedOperationsService } from '../../../core/services/shared-operations.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cta-panel',
  templateUrl: './cta-panel.component.html',
  styleUrls: ['./cta-panel.component.scss'],
  standalone: false
})


export class CtaPanelComponent implements OnInit {
  project:any;
  ctaMessage: string = '';
  ctaButtonText: string = '';
  ctaButtonLink: string = '';

  constructor(private router: Router, private projectService: ProjectService, private sharedOperationsService: SharedOperationsService) {}

  ngOnInit(): void {
    this.projectService.getProjectData(this.sharedOperationsService.getKainicPidFromLocalStorage()).then((project: any) => {
      this.project = project;
      if (!this.project || !this.project.billing_account_id || this.project.billing_account_id === null) {
        this.ctaMessage = 'Please Connect a Billing Account to your Project, and Top Up Your Project Credit to use all Project Features';
        this.ctaButtonText = 'Connect Billing Account';
        this.ctaButtonLink = '/settings/billing-accounts';
      } else {
        this.ctaMessage = 'Please Top Up Your Project Credit to use all Project Features';
        this.ctaButtonText = 'Top Up Your Credit';
        this.ctaButtonLink = `/projects/${this.project.id}/billing/overview`;
      }
    });
  }

  onCtaClick() {
    this.router.navigate([this.ctaButtonLink]);
  }
}
